import { render, staticRenderFns } from "./bfcoreword.vue?vue&type=template&id=6b16fa42&scoped=true&"
import script from "./bfcoreword.vue?vue&type=script&lang=js&"
export * from "./bfcoreword.vue?vue&type=script&lang=js&"
import style0 from "./bfcoreword.vue?vue&type=style&index=0&id=6b16fa42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b16fa42",
  null
  
)

export default component.exports